const FormFieldContextKey = Symbol("fh-form-field-context");
const ForcedStandaloneKey = Symbol("fh-form-field-forced-standalone");
const InputFieldContextKey = Symbol("inputFieldContext");
export {
  ForcedStandaloneKey,
  FormFieldContextKey,
  InputFieldContextKey
};
//# sourceMappingURL=Symbols.mjs.map
